module.exports = __webpack_public_path__ + "static/media/SVGPhone.27df0e91.svg";